import React from 'react';
import { Link } from 'react-router-dom';
import Style from './style.module.scss';
import Logo from './../../assets/img/logo/logo.svg';

const HeaderLogo = () => {
  return (
    <>
      <div className={Style.mask}>
        <Link to="/">
          <img src={Logo} alt="NGAMING logo" />
        </Link>
      </div>

      <svg height="0" width="0" aria-hidden="true">
        <mask id="mask-firefox">
          <image width="145" height="29" href={Logo} filter="url(#filter)" />
        </mask>

        <filter id="filter">
          <feFlood floodColor="white" />
          <feComposite in2="SourceAlpha" operator="in" />
        </filter>
      </svg>
    </>
  );
};

export default HeaderLogo;
